import Axios from 'axios'
const BASEURL = 'https://api.everythingcheeranddance.com/public/'
// const BASEURL = 'http://localhost:8000/public/'
const API = {
  headers: function() {
    return {
      headers:{'Authorization':localStorage.ECDsessionid}
    };
  },
  loginUser: function (email,password) {
    return Axios.post(BASEURL + 'user/login', {
      email: email,
      password: password
    })
  },
  facebookLogin: function (firstName, lastName, email, facebookId, newsletter) {
    return Axios.post(BASEURL + 'user/login/facebook', {
      first_name: firstName,
      last_name: lastName,
      email: email,
      facebookId: facebookId,
      newsletter: newsletter
    })
  },
  registerUser: function (firstName, lastName, email,password,newsletter) {
    return Axios.post(BASEURL + 'user/create', {
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password,
      newsletter: newsletter
    })
  },
  getUserId: function (sessionId) {
    let url = BASEURL + 'user/id?session=' + sessionId
    return Axios.get(url, {
    })
  },
  getAdminServices: function () {
    let url = BASEURL + 'admin/services'
    return Axios.get(
      url,
      this.headers()
    );
  },
  getAdminListings: function () {
    let url = BASEURL + 'admin/listings'
    return Axios.get(
      url,
      this.headers()
    );
  },
  removeListing: function (id) {
    let url = BASEURL + 'admin/listing/remove'
    return Axios.post(
      url,
      {id:id},
      this.headers()
    );
  },
  getAdminListing: function (listingId) {
    let url = BASEURL + `admin/listing?listingId=${listingId}` 
    return Axios.get(
      url,
      this.headers()
    );
  },
  createAdminService: function (form) {
    let url = BASEURL + 'admin/service/create'
    return Axios.post(url,{
      name: form.name,
      accountRequired: form.accountRequired,
      archiveAfterCompletion: form.archiveAfterCompletion,
      removeAfter6Months: form.removeAfter6Months,
      slug:form.slug
    },
    this.headers());
  },
  updateAdminService: function (serviceId,form) {
    let url = BASEURL + 'admin/service/update'
    return Axios.post(url,{
      serviceId: serviceId,
      name: form.name,
      accountRequired: form.accountRequired,
      archiveAfterCompletion: form.archiveAfterCompletion,
      removeAfter6Months: form.removeAfter6Months,
      description:form.description
    },
    this.headers());
  },
  createAdminServiceField: function (form) {
    let url = BASEURL + 'admin/service/createField'
    return Axios.post(url,{
      serviceId: form.serviceId,
      name: form.name,
      required: form.required,
      type: form.type,
      searchable: form.searchable,
      characterLimit: form.characterLimit,
      selectOptions: form.selectOptions,
      showInTableOnSmall: form.showInTableOnSmall,
      showInTable: form.showInTable
    },this.headers());
  },
  retrieveAdminService: function (id) {
    let url = BASEURL + 'admin/service?serviceId=' + id
    return Axios.get(url,this.headers());
  },
  getListings: function (userId) {
    let url = BASEURL + 'listings?userId=' + userId
    return Axios.get(url,this.headers());
  },
  getListing: function (userId,listingId) {
    let url = BASEURL + `listing?userId=${userId}&listingId=${listingId}`
    return Axios.get(url,this.headers());
  },
  getServices: function (sort) {
    let url = BASEURL + 'services?sort=' + sort
    return Axios.get(url,this.headers());
  },
  getService: function (serviceId) {
    let url = BASEURL + 'service?serviceId=' + serviceId
    return Axios.get(url,this.headers());
  },
  getServiceBySlug: function (slug) {
    let url = BASEURL + 'service/slug?slug=' + slug
    return Axios.get(url,this.headers());
  },
  getFields: function (serviceId) {
    let url = BASEURL + 'service/fields/' + serviceId
    return Axios.get(url,this.headers());
  },
  saveListing: function (serviceId,userId,price,priceName,form,cityStates,hasCoupon,couponName,city,state,photo,background,textColor) {

    let url = BASEURL + 'listings/create'

    let headers = this.headers()
    headers['headers']['Content-Type'] = 'image/png'

    let formData = new FormData();
    formData.append('photo',photo)

    let states = cityStates.map(it => {
      return it.state
    });

    formData.append('serviceId',serviceId)
    formData.append('userId',userId)
    formData.append('price',price)
    formData.append('priceName',priceName)
    formData.append('cityStates',JSON.stringify(states))
    formData.append('hasCoupon',hasCoupon)
    formData.append('couponName',couponName)
    formData.append('city',city)
    formData.append('state',state)
    formData.append('fromNew',true)
    formData.append('backgroundColor',background)
    formData.append('textColor',textColor)

    let formIds = Object.keys(form);
    formIds.forEach(id => {
      formData.append('form_' + id.toString(),form[id].toString())
    });

    formData.append('formIds',formIds.toString())

    return Axios.post(url,formData,headers);
  },
  updateListing: function (listing) {

    let url = BASEURL + 'listing/update'
    let headers = this.headers()
    headers['headers']['Content-Type'] = 'image/png'

    let formData = new FormData();
    formData.append('fields',JSON.stringify(listing.fields))
    formData.append('city',listing.city)
    formData.append('state',listing.state)
    formData.append('listingId',listing.id)
    formData.append('photo',listing.photo)
    formData.append('fromNew',true)
    formData.append('didChangePhoto',listing.didChangePhoto)
    formData.append('didRemovePhoto',listing.didRemovePhoto)
    formData.append('backgroundColor',listing.bgColor)
    formData.append('textColor',listing.tColor)


    return Axios.post(url,formData,headers);
  },
  cancelFreeListing: function (listingId) {

    let url = BASEURL + 'listing/cancelFree'
    return Axios.post(url,{
      listingId:listingId
    },this.headers());
  },
  getFeed: function (serviceId,userId,type) {
    let url = BASEURL + `feed/services/listings?serviceId=${serviceId}&userId=${userId}&type=${type}`
    return Axios.get(url,this.headers());
  },
  getNewListings: function () {
    let url = BASEURL + `feed/new`
    return Axios.get(url,this.headers());
  },
  getServiceFields: function (serviceId) {
    let url = BASEURL + 'service/fields/' + serviceId
    return Axios.get(url,this.headers());
  },
  favorite: function(listingId, userId) {
    let url = BASEURL + 'user/favorite'
    return Axios.post(url,{
      listingId: listingId,
      userId: userId
    },this.headers());
  },
  unfavorite: function(listingId, userId) {
    let url = BASEURL + 'user/unfavorite'
    return Axios.post(url,{
      listingId: listingId,
      userId: userId
    },this.headers());
  },
  getFavorites: function(userId) {
    let url = BASEURL + 'user/favorites?userId=' + userId
    return Axios.get(url,this.headers());
  },
  adminGetUsers: function() {
    let url = BASEURL + 'admin/users'
    return Axios.get(url,this.headers());
  },
  adminGetCoupons: function() {
    let url = BASEURL + 'admin/coupons'
    return Axios.get(url,this.headers());
  },
  adminCreateCoupon: function(name) {
    let url = BASEURL + 'admin/coupon'
    return Axios.post(url,{
      name:name
    },this.headers());
  },
  adminEnableCoupon: function(couponId) {
    let url = BASEURL + 'admin/coupon/update'
    return Axios.post(url,{
      couponId:couponId,
      enabled:1
    },this.headers());
  },
  adminDisableCoupon: function(couponId) {
    let url = BASEURL + 'admin/coupon/update'
    return Axios.post(url,{
      couponId:couponId,
      enabled:0
    },this.headers());
  },
  getAdminStats: function () {
    let url = BASEURL + 'admin/stats'
    return Axios.get(
      url,
      this.headers()
    );
  },
  getAdminSettings: function () {
    let url = BASEURL + 'admin/settings'
    return Axios.get(
      url,
      this.headers()
    );
  },
  updateAdminSetting: function (setting) {
    let url = BASEURL + `admin/setting`
    return Axios.post(
      url,
      {
        settingId:setting.id,
        val:setting.val
      },
      this.headers()
    );
  },
  
  getAnnouncements: function () {
    let url = BASEURL + '/announcements'
    return Axios.get(
      url,
      this.headers()
    );
  },

  getAdminAnnouncements: function () {
    let url = BASEURL + 'admin/announcements'
    return Axios.get(
      url,
      this.headers()
    );
  },
  updateAdminAnnouncement: function (announcement) {
    let url = BASEURL + `admin/announcements`
    return Axios.put(
      url,
      {
        id:announcement.id,
        title:announcement.title,
        description:announcement.description
      },
      this.headers()
    );
  },
  createAdminAnnouncement: function (announcement) {
    let url = BASEURL + `admin/announcements`
    return Axios.post(
      url,
      {
        title:announcement.title,
        description:announcement.description
      },
      this.headers()
    );
  },


  search: function (form,serviceId,userId) {
    let url = BASEURL + 'feed/services/search'
    return Axios.post(
      url,
      {
        form: form,
        serviceId: serviceId
      },
      this.headers()
    );
  },
  forgotPassword: function(email) {
    let url = BASEURL + 'user/forgotPassword'
    return Axios.post(
      url,
      {
        email:email
      }
    );
  },
  resetPassword: function(id,password,key) {
    let url = BASEURL + 'user/resetPassword'
    return Axios.post(
      url,
      {
        id:id,
        newPassword:password,
        key:key
      }
    );
  },

  adminDisableServiceField: function(fieldId) {
    let url = BASEURL + 'admin/service/field/disable'
    return Axios.post(
      url,
      {
        fieldId:fieldId
      },
      this.headers()
    );
  },
  getThreeMonthTrial: function(fieldId) {
    let url = BASEURL + 'settings/threeMonthTrial'
    return Axios.get(
      url,
      this.headers()
    );
  },
  getPrices: function(fieldId) {
    let url = BASEURL + 'settings/prices'
    return Axios.get(
      url,
      this.headers()
    );
  },
  validateCoupon: function(name) {
    let url = BASEURL + 'coupon?name=' + name
    return Axios.get(
      url,
      this.headers()
    );
  },
  confirmEmail: function(token) {
    let url = BASEURL + 'user/email/confirm'
    return Axios.post(
      url,
      {
        email:token
      },
      this.headers()
    );
  },
  getUser: function(userId) {
    let url = BASEURL + 'user/retrieve/' + userId
    return Axios.get(
      url,
      this.headers()
    );
  },
  updateUser: function(user) {
    let url = BASEURL + 'user/update'

    let data = {
      userId:user.id,
      first_name:user.first_name,
      last_name:user.last_name,
      email:user.email
    }

    if(user.password && user.password.length > 0) {
      data.password = user.password
    }

    return Axios.post(
      url,
      data,
      this.headers()
    );
  },
  sendAccountEmail: function(userId) {
    let url = BASEURL + 'user/email/send'

    let data = {
      userId:userId
    }

    return Axios.post(
      url,
      data,
      this.headers()
    );
  },

  sendContactUsEmail: function(form) {
    let url = BASEURL + 'email/contact'
    return Axios.post(
      url,
      form
    );
  },
  getFacebookUser: function (accessToken) {
    let url = `https://graph.facebook.com/v6.0/me?fields=id%2Cfirst_name%2Clast_name%2Cemail&access_token=${accessToken}`
    return Axios.get(url)
  },
}

export default API



// WEBPACK FOOTER //
// ./src/API/API.js